import {
  CheckboxField,
  NewResourceForm,
  NumberField,
  ObjectField,
  processStateOptions,
  SelectField,
  WorkflowSelect,
} from "~/components/Form";
import { useCreateDigestionPart } from "~/domain/datastores";
import { makeDigestionPartLocation, useDigestionParams } from "~/paths";
import { ProcessState } from "~/services/datastore";
import { createDigestionPartSchema } from "../schemas";

export function DigestionPartCreateForm() {
  const { digestionId } = useDigestionParams();

  return (
    <NewResourceForm
      schema={createDigestionPartSchema}
      defaultValues={{
        sequence: null,
        workflowId: null,
        workflowContext: null,
        state: ProcessState.Ready,
        locked: false,
      }}
      resourceName="digestion part"
      mutation={useCreateDigestionPart(digestionId)}
      generateLocation={(response) =>
        makeDigestionPartLocation({
          digestionId,
          digestionPartId: response.data.id,
        })
      }
    >
      {(control) => (
        <>
          <NumberField control={control} name="sequence" required />
          <SelectField
            control={control}
            name="state"
            options={processStateOptions}
            required
          />
          <WorkflowSelect control={control} name="workflowId" />
          <ObjectField control={control} name="workflowContext" />
          <CheckboxField control={control} name="locked" />
        </>
      )}
    </NewResourceForm>
  );
}
